import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NoContent } from 'view/organisms';
import { Text, Icon } from 'view/atoms';
import { ROUTES } from 'config';
import { plus } from 'static/icons/resizable';
import { useCheckRoles } from 'hooks';
import { UserRole } from 'interfaces';
import { LocationButton } from './components/LocationButton';
import { useCheckDiscounts } from './hooks';
import * as S from './NoDiscountsPage.styles';

export const NoDiscountsPage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  useCheckDiscounts();

  const isForHr = useCheckRoles(UserRole.Mod);

  return (
    <S.NoDiscountsPage>
      <NoContent
        title={t('noDiscountsInLocationPage.title')}
        description={t('noDiscountsInLocationPage.description')}
      >
        <>
          <LocationButton />

          {isForHr && (
            <S.ButtonAddDiscount
              kind='primary'
              type='button'
              onClick={() => navigate(`${ROUTES.discountEditor}`)}
            >
              <Icon src={plus} alt='up' />
              <Text kind='button' color='gray1'>
                {t('mainPage.addDiscount')}
              </Text>
            </S.ButtonAddDiscount>
          )}
        </>
      </NoContent>
    </S.NoDiscountsPage>
  );
};
